export enum I18NNamespace {
  General = "tixSearchForm_general",
  Mobile = "tixSearchForm_mobile",
}
